<template>
  <div class="consent-checkbox-container">
    <v-checkbox class="consent-checkbox" v-model="isChecked" color="var(--blueText)">
      <template v-slot:label>
        <div class="consent-checkbox__label-container">
          <span class="consent-checkbox__label-text" v-html="label"></span>
          <span
            v-if="hasModal"
            class="consent-checkbox__read-more"
            @click.stop.prevent="$emit('readMore')"
          >Read more...</span>
        </div>
      </template>
    </v-checkbox>
  </div>
</template>

<script>
  export default {
    name: 'ConsentCheckbox',
    props: {
      value: Boolean,
      label: String,
      hasModal: Boolean
    },
    computed: {
      isChecked: {
        get () {
          return this.value
        },
        set (isChecked) {
          this.$emit('input', isChecked)
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .consent-checkbox-container {
    padding: 4px 0;
  }
  .consent-checkbox__label-container {
    display: flex;
    flex-direction: column;
  }
  .consent-checkbox__label-text {
    font-size: 13px;
    line-height: 1.4;
  }
  .consent-checkbox__read-more {
    font-size: 12px;
    color: var(--blueText);
    cursor: pointer;
    text-decoration: underline;
    margin-top: 2px;
  }
</style>
